var _path, _ellipse, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeeFly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 124,
    viewBox: "0 0 244 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.128 68.4666C133.644 68.6645 125.802 17.2245 99.4919 45.8024C73.18 74.3794 33.7065 37.6258 48.4578 26.2137C63.2084 14.8001 77.8146 47.7078 58.2071 62.6751C38.597 77.6427 11.9013 72.0287 1.48924 58.6597",
    stroke: "#040505",
    strokeWidth: 2.20107,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.34 7.34"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.909,
    cy: 76.5445,
    rx: 24.4718,
    ry: 13.3699,
    transform: "rotate(17.2023 195.909 76.5445)",
    fill: "#FFCC2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.851 69.9367L171.463 72.1645C172.471 73.0195 174.025 72.5682 174.416 71.3065L175.217 68.7196C175.608 67.4546 174.581 66.2057 173.265 66.3423L169.852 66.7047C168.244 66.8732 167.621 68.8881 168.851 69.9368L168.851 69.9367Z",
    fill: "#040505"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.666 68.9172C171.087 73.1568 173.604 78.1781 178.724 82.4081L185.045 61.9922C178.87 62.5452 174.141 64.9542 172.666 68.9172Z",
    fill: "#040505"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.152 84.1693C220.729 79.9299 218.215 74.9084 213.095 70.6816L206.774 91.0944C212.949 90.5414 217.678 88.1324 219.152 84.1693Z",
    fill: "#040505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.578 64.0017C198.735 63.3947 196.904 62.9402 195.105 62.5937L187.363 87.5989C188.606 88.139 189.89 88.6475 191.241 89.0894C193.081 89.6932 194.915 90.1508 196.713 90.4941L204.455 65.4922C203.212 64.9487 201.925 64.4434 200.578 64.0016L200.578 64.0017Z",
    fill: "#040505"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 219.285,
    cy: 83.7813,
    r: 10.502,
    transform: "rotate(90 219.285 83.7813)",
    fill: "#040505"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.83 106.001C203.324 103.338 207.392 93.6958 209.298 88.5664C209.934 86.8534 208.841 85.007 207.029 84.7401C201.617 83.9487 191.206 82.8872 186.712 85.5473C180.502 89.2274 178.182 96.788 181.528 102.436C184.875 108.083 192.62 109.678 198.83 106.001L198.83 106.001Z",
    fill: "#CECECE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.355 55.8466C216.558 60.5787 214.466 70.8344 213.141 76.1417C212.696 77.9183 210.751 78.824 209.108 78.0199C204.195 75.6142 195.004 70.6055 192.801 65.8734C189.757 59.3297 192.112 51.7786 198.064 49.0105C204.017 46.2424 211.311 49.2998 214.355 55.8466L214.355 55.8466Z",
    fill: "#CECECE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M224.543 85.4102L234.729 82.8926L224.543 85.4102Z",
    fill: "#FFCC2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M224.543 85.4102L234.729 82.8926",
    stroke: "#040505",
    strokeWidth: 2.14924,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M224.54 85.4102L231.521 93.2428L224.54 85.4102Z",
    fill: "#FFCC2E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M224.54 85.4102L231.521 93.2428",
    stroke: "#040505",
    strokeWidth: 2.14924,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeFly);
export default __webpack_public_path__ + "static/media/BeeFly.8fbed02b89f58348fb6351baeb3bc05c.svg";
export { ForwardRef as ReactComponent };